import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { format, parseISO } from "date-fns";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faMapMarkerAlt, faTicketAlt } from '@fortawesome/free-solid-svg-icons';
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import './css/style.css';
const EventPage = () => {
    const { eventId } = useParams();
    // console.log("eventId:", eventId); // ✅ Log it here
    const [event, setEvent] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchEvent = async () => {
            // The server calls Facebook for us, so the access token stays private
            const url = `/api/FacebookEvents/facebook/${encodeURIComponent(eventId)}`;

            try {
                const response = await fetch(url);

                if (!response.ok) {
                    console.error("Event fetch failed:", response.status);
                    setError(response.status === 404 ? "Event not found" : "Could not load event");
                } else {
                    setEvent(await response.json());
                }
            } catch (err) {
                console.error("Network error:", err);
                setError("Network error");
            }
        };

        if (eventId) {
            fetchEvent();
        }
    }, [eventId]);

    if (error) return <div>Error: {error}</div>;
    if (!event) return <div>Loading...</div>;

    const formatGoogleCalendarLink = (event) => {
        const startTime = new Date(event.start_time).toISOString().replace(/-|:|\.\d+/g, ""); // Google format
        const endTime = new Date(event.end_time || event.start_time).toISOString().replace(/-|:|\.\d+/g, "");
        const eventTitle = encodeURIComponent(event.name);
        const eventDetails = encodeURIComponent(event.description || "");
        const eventLocation = encodeURIComponent(event.place?.name || "Online");

        return `https://calendar.google.com/calendar/r/eventedit?text=${eventTitle}&dates=${startTime}/${endTime}&details=${eventDetails}&location=${eventLocation}`;
    };

    const eventDate = parseISO(event.start_time);
    const formattedDate = format(eventDate, "MMMM d, yyyy");
    const formattedTime = format(eventDate, "h:mm a");
    const monthName = format(eventDate, "MMM");
    const day = format(eventDate, "d");

    return (
        <div className="main-event-cont">
            <div className="details-cont">

                <div className="sk-event-item-thumbnail-date">
                    <div className="sk-event-item-thumbnail-month">
                        <p>{monthName}</p>
                    </div>
                    <div className="sk-event-item-thumbnail-day">
                        {/*<p>{event.start_date.lastIndexOf(",") > 1 ? event.start_date.slice(event.start_date.lastIndexOf(",") - 2, event.start_date.lastIndexOf(",")) : ""}</p>*/}

                        <p>{day}</p>
                    </div>
                </div>

                <div className="details">
                    <h3>{event.name}</h3>
                    <p>
                        <FontAwesomeIcon icon={faCalendarAlt} size="1x" color="grey" /> {formattedDate + " at " + formattedTime}
                    </p>

                    <p>
                        {event.place && event.place.name ? (
                            <>
                                <FontAwesomeIcon icon={faMapMarkerAlt} size="1x" color="grey" />
                                <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(event.place.name)}`} target="_blank" rel="noopener noreferrer">
                                     {event.place.name}
                                </a>
                            </>
                        ) : ""}
                    </p>
                    <p> {event.ticket_uri ? <span><FontAwesomeIcon icon={faTicketAlt} size="1x" color="grey" /> <a href={event.ticket_uri} target="_blank" rel="noopener noreferrer"> Get Tickets</a></span> : ""}</p> {/*JSX*/}
                    <p>
                        <a href={`https://facebook.com/events/${event.id}`} target="_blank" rel="noopener noreferrer">
                            View Event on Facebook
                        </a>
                    </p>
                    <p>
                        {event.description}
                    </p>
                </div>
            </div>
            <div className="social" >
                <div>
                    <a href="https://www.facebook.com/dysyachtrock" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#3b5998', fontSize: '1.2rem', display: 'inline-flex', alignItems: 'center', gap: '8px', marginRight: '1rem' }}><FontAwesomeIcon icon={faFacebookF} size="lg" />Make sure to like us on Facebook!</a>
                </div>
                <div>
                    <a href="https://www.instagram.com/dirtyyachtin" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#E1306C', fontSize: '1.2rem', display: 'inline-flex', alignItems: 'center', gap: '8px' }}><FontAwesomeIcon icon={faInstagram} size="lg" />Follow us on Instagram!</a>
                </div>
            </div>
        </div>

    );
};

export default EventPage;
